<template>
  <div class="teams color-normal">
    <div v-if="!isServerSport">
      <div
        class="row flex flex-center-vertical"
        v-for="(team, index) in teams"
        :key="index">
        <span class="text-cut">
          {{ team.nameShort }}
        </span>
        <card-red
          :count="status.redCards[index]"
          v-if="status.redCards && status.redCards[index]"
        />
        <span class="filler" />
        <span
          class="period font-bold text-center flex-noshrink color-faded"
          :class="{ 'color-important': iPeriod === 0 }"
          v-for="(period, iPeriod) in resultPeriod"
          :key="iPeriod">
          {{ period[index] }}
        </span>
      </div>
    </div>
    <div v-else>
      <div
        class="row flex flex-center-vertical"
        v-for="(team, index) in teams"
        :key="index">
        <span class="text-cut">
          {{ team.nameShort }}
        </span>
        <span class="filler" />
        <span
          class="period font-bold text-center color-faded flex-noshrink"
          :class="{ 'color-important': iPeriod === resultPeriod.length - 1 && !isTennis,
                    'color-normal': iPeriod === resultPeriod.length - 1 ||
                      (iPeriod !== resultPeriod.length - 1 ?
                        isHigher(resultPeriod[iPeriod][index === 0 ? 0 : 1],
                                 resultPeriod[iPeriod][index === 0 ? 1 : 0])
                        : false)
          }"
          v-for="(period, iPeriod) in resultPeriod"
          :key="iPeriod">
          {{ period[index] }}
        </span>
        <span
          class="period period-game font-bold color-important text-center flex-noshrink"
          v-if="gameScore">
          {{ gameScore[index] }}
        </span>
        <span class="icon-server-wrapper">
          <transition name="server-fade">
            <span
              class="icon-server middle"
              v-if="(index+1) === status.server"
              :key="index"
            />
          </transition>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { sport, comparison, resultPeriodMedium } from '@/services/mixins';
import CardRed from '@/components/common/card-red/CardRed.vue';

export default {
  name: 'MatchTeams',
  mixins: [sport, comparison, resultPeriodMedium],
  components: {
    CardRed,
  },
  props: {
    idMatch: {
      required: true,
      type: Number,
    },
    idSport: {
      required: true,
      type: Number,
    },
  },
  computed: {
    teams() {
      return this.$store.getters.getMatchTeams(this.idMatch);
    },
    status() {
      return this.$store.getters.getMatchStatus(this.idMatch);
    },
    gameScore() {
      return Object.prototype.hasOwnProperty.call(this.status, 'gameScore')
        ? this.status.gameScore.split(':') : undefined;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.teams {
  float: left;
  width: 100%;
  padding-left: 1.041667vw;
  padding-right: 0.5208vw;

  .row {
    height: 4.5vh;
    line-height: 4.5vh;

    .text-cut {
      font-size: 1.125rem;
      font-weight: 500;
    }
  }
}

.period {
  width: 2.60417vw;
}

.period-game {
  width: 3.125vw;
}

.icon-server-wrapper {
  position: relative;
  padding: 0 10px;

  .icon-server {
    width: $match-icon-server-width;
    height: $match-icon-server-width;
    border-radius: 50%;
    background-color: $color-important;
  }
}
</style>
